<template>
<div class="m-module">
    <div class="section">
        <div class="page-title">
            {{ $t("lang.Security") }}
        </div>
        <van-cell-group>
            <van-cell is-link @click="toggle2FA">
                <template #title>
                    <div class="cell-title">
                        <div class="cell-icon">
                            <img class="img" :src="require('@/assets/img/secure_2fa.svg')" />
                        </div>
                        <div class="cell-info">
                            <div class="cell-text">
                                {{ $t("lang.Authentication") }}
                                <span class="status  status-success" v-if="!userInfo.doubleCheck">
                                    <i class="status-icon el-icon-error"></i>
                                    <span class="text" >{{ $t("lang.OFF") }}</span>
                                </span>
                                <span class="status  status-success" v-else>
                                    <i class="status-icon el-icon-success"></i>
                                    <span class="text" >{{ $t("lang.ON") }}</span>
                                </span>
                            </div>
                            <div class="cell-desc"></div>
                        </div>
                    </div>
                </template>
            </van-cell>
            <van-cell is-link @click="changePopup()">
                <template #title>
                    <div class="cell-title">
                        <div class="cell-icon">
                            <img class="img" :src="require('@/assets/img/secure_email.svg')" />
                        </div>
                        <div class="cell-info">
                            <div class="cell-text">{{ $t("lang.Email") }}</div>
                            <div class="cell-desc">{{ $t("lang.account") }}</div>
                        </div>
                    </div>
                </template>
            </van-cell>
            <van-cell is-link @click="pwdPopup=true">
                <template #title>
                    <div class="cell-title">
                        <div class="cell-icon">
                            <img class="img" :src="require('@/assets/img/secure_pwd.svg')" />
                        </div>
                        <div class="cell-info">
                            <div class="cell-text">{{ $t("lang.LoginPassword") }}</div>
                            <div class="cell-desc">{{ $t("lang.textPassword") }}</div>
                        </div>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
    </div>
    <van-popup v-model="mailPopup" position="bottom" @close="closeMailPopup" closeable :style="{ height: '50%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">{{ $t("lang.Modify") }}</h3>
            </div>
            <van-divider />
            <div class="bd">
                <div class="titleEmail">
                   <div class="email">{{ $t("lang.Email") }}：{{userInfo.email}}</div>
                   <div class="sub">
                    <van-button  block type="primary" @click=" twoFAVerify(userInfo)">{{ $t('lang.sendVerifyCode') }}</van-button>
                   </div>
                </div>
                <div class="form-container">
                    <van-form>
                        <van-field v-model="form.verifyCode" name="verifyCode1" :label="$t('lang.VerifyCode')" :placeholder="$t('lang.textVerifyCode')" />
                        <van-field v-model="form.email" name="verifyCode1" :label="$t('lang.NewEmail')" :placeholder="$t('lang.textEmailAddress')" />
                    </van-form>
                </div>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block type="primary" @click=" sendEdit">{{ $t("lang.submit") }}</van-button>
                </div>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="pwdPopup" position="bottom"  @close="closePwdPopup" closeable :style="{ height: '50%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">{{ $t("lang.loginModify") }} <span class="password" @click="forgotPassword">{{ $t("lang.ForgotPassword") }}</span></h3>
               
            </div>
            <van-divider />
            <div class="bd">
                <!-- <div class="titleEmail">
                   <div class="email">{{ $t("lang.Email") }}：{{userInfo.email}}</div>
                   <div class="sub">
                    <van-button  block type="primary" @click=" twoFAVerify(userInfo)">{{ $t('lang.sendVerifyCode') }}</van-button>
                   </div>
                </div> -->
                <div class="form-container">
                    <van-form>
                        <van-field type="password" v-model="formPassword.oldPassword" name="password" :label="$t('lang.OldPassword')" :placeholder="$t('lang.oldPassword')" />
                        <van-field type="password" v-model="formPassword.newPassword" name="newPassword" :label="$t('lang.NewPassword')" :placeholder="$t('lang.newPassword')" />
                        <van-field type="password" v-model="formPassword.password" name="newPassword" :label="$t('lang.ConfirmNewPassword')" :placeholder="$t('lang.againPassword')" />
                    </van-form>
                </div>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block type="primary" @click="changePassword">{{ $t("lang.submit") }}</van-button>
                </div>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="forgotPopup" position="bottom" closeable @close="closeForgotPopup" :style="{ height: '50%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">{{ $t("lang.PasswordModify") }}</h3>
            </div>
            <van-divider />
            <div class="bd">
                <div class="titleEmail">
                   <div class="email">{{ $t("lang.Email") }}：{{userInfo.email}}</div>
                   <div class="sub">
                    <van-button  block type="primary" @click=" twoFAVerify(userInfo)">{{ $t('lang.sendVerifyCode') }}</van-button>
                   </div>
                </div>
                <div class="form-container">
                    <van-form>
                        <van-field v-model="formList.verifyCode" name="verifyCode1" :label="$t('lang.VerifyCode')" :placeholder="$t('lang.textVerifyCode')" />
                        <!-- <van-field v-model="formList.email" name="verifyCode1" label="New Email" placeholder="Please enter new email address" /> -->
                        <van-field type="password" v-model="formList.password" name="newPassword" :label="$t('lang.ConfirmNewPassword')" :placeholder="$t('lang.againPassword')" />
                    </van-form>
                </div>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block type="primary" @click=" possWordEdit">{{ $t("lang.submit") }}</van-button>
                </div>
            </div>
        </div>
    </van-popup>
</div>
</template>
<script>
import Header from "@/components/mobile/header";
import lineChart from "@/views/account/modules/lineChart.vue";
import { Dialog } from 'vant';
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet,axiosPost} from '@/api/api';
export default {
    name:'account-m',
    components: {
        Header,
        lineChart,
    },
    data(){
        return {
            mailPopup:false,
            pwdPopup:false,
            forgotPopup:false,
            form:{
                verifyCode:'',
                email:'',
            },
            formPassword:{
                oldPassword:'',
                newPassword:'',
                password:'',
            },
            formList:{
                verifyCode:'',
                password:''
            },
            userInfo:{},
            url:{
                sendCode:BASE_GLOB_API+'/register/verifyCode/send',
                edit:BASE_GLOB_API+'/user/edit',
                info:BASE_GLOB_API+'/user/info',
            },
            lang: "",
        }
    },
    mounted(){
       
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
        this.useInfo()
    },
    methods:{
        useInfo(){
          
            axiosGet(this.url.info).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.userInfo =res.result
                    window.sessionStorage.setItem("userinfo", JSON.stringify(this.userInfo));
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        closeMailPopup(){
            this.mailPopup =false
            this.form.verifyCode ='';
            this.form.email ='';
        },
        closePwdPopup(){
            this.pwdPopup =false
            this.formPassword.oldPassword ='';
            this.formPassword.newPassword ='';
            this.formPassword.password ='';
        },
        closeForgotPopup(){
            this.forgotPopup =false
            this.formList.verifyCode ='';
            this.formList.password ='';
        },
        possWordEdit(){
            if(!this.formList.verifyCode){
                this.$message.error(this.$t("lang.textVerifyCode"));
                return;
            }
            if(!this.formList.password){
                this.$message.error(this.$t("lang.newPassword"));
                return;
            }
            let params = {
                account:this.userInfo.account,
                // email:this.formList.email,
                verifyCode:this.formList.verifyCode,
                password:this.formList.password,
            }
            axiosPost(this.url.edit, params).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.forgotPopup =false
                    this.formList.verifyCode ='';
                    this.formList.password ='';
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        forgotPassword(){
        //    this.twoFAVerify(this.userInfo)
           this.pwdPopup =false;
           this.forgotPopup =true;
        },
        changePassword(){
            if(!this.formPassword.oldPassword){
                this.$message.error(this.$t("lang.oldPassword"));
                return;
            }
            if(!this.formPassword.newPassword){
                this.$message.error(this.$t("lang.newPassword"));
                return;
            }
            if(!this.formPassword.password){
                this.$message.error(this.$t("lang.againPassword"));
                return;
            }
            if(this.formPassword.newPassword != this.formPassword.password){
                this.$message.error(this.$t("lang.PasswordText"));
                return;
            }
           
            let params = {
                account:this.userInfo.account,
                oldPassword:this.formPassword.oldPassword,
                password:this.formPassword.password,
            }
            axiosPost(this.url.edit, params).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.pwdPopup =false
                    this.formPassword.oldPassword ='';
                    this.formPassword.password ='';
                    this.formPassword.newPassword ='';
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        sendEdit(){
            if(!this.form.verifyCode){
                this.$message.error(this.$t("lang.textVerifyCode"));
                return;
            }
            if(!this.form.email){
                this.$message.error(this.$t("lang.textEmailAddress"));
                return;
            }
            let params = {
                account:this.userInfo.account,
                email:this.form.email,
                verifyCode:this.form.verifyCode,
            }
            axiosPost(this.url.edit, params).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.mailPopup =false
                    this.form.email ='';
                    this.form.verifyCode ='';
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        twoFAVerify(data){
            
            let params = {
                email:data.email
            }
            axiosGet(this.url.sendCode, params,60000).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        changePopup(){
           this.mailPopup =true
        //    this.twoFAVerify(this.userInfo)
        },
        toggle2FA(){
            Dialog.confirm({
                //title:'标题',
                message:this.$t("lang.enable"),
                confirmButtonText:this.$t("lang.confirmText"),
                cancelButtonText:this.$t("lang.cancelText")
            }).then(()=>{
               this.confirm()
            }).catch(()=>{
                console.log("cancel")
            })
        },
        confirm(){
            axiosPost(this.url.edit,{doubleCheck: !this.userInfo.doubleCheck}).then(res=>{
              if(res.success){
                this.useInfo() 
              }else{
                  this.$message.error(res.message);
              }
              
          })
        },
    }
}
</script>
<style lang="less" scoped>
.m-module {
    .section {
        .page-title {
            font-size:20px; font-weight:600; padding:30px 15px;
        }
        .cell-title {
            display:flex; justify-content: flex-start; align-items: flex-start;
            .cell-icon {
                width:32px; min-width:32px; height:32px;
                .icon {width:100%; height:100%;}
            }
            .cell-info {
                padding:0 0 0 10px;
                .cell-text {
                    font-size:16px; font-weight:700;
                    .status {
                            padding-left: 15px;
                            .status-icon {
                                font-size:14px; margin-right:4px;
                            }
                            .text {
                                font-weight:700;
                            }
                            &.status-success {
                                .status-icon {color:#44ac30;}
                            }
                            &.status-error {
                                .status-icon {color:#f06c5d;}
                            }
                            &.status-warning {
                                .status-icon {color:#ffba40;}
                            }
                            &.status-default {
                                color:#999;
                                .status-icon {color:#999;}
                            }
                        }
                }
                .cell-desc {
                    font-size:10px; color:#999;
                }
            }
        }
    }
}
.popup-mod {
    height:100%; position:relative; overflow: hidden;
    .hd {
        padding:16px 16px;
        .title {
            font-size:16px; font-weight:700;
        }
        .password{
            color:#4358fe ;
            padding-left: 70px;
        }
    }
    .van-divider {margin:0;}
    .bd {
        position:absolute; top:52px; left:0; right:0; bottom:54px; overflow:auto;
        .form-container {
            ::v-deep .van-field {
                display:block;
                .van-field__label {
                    width:auto;
                }
            }
        }
    }
    .ft {
        position:absolute; z-index:1; left:0; bottom:0; right:0; height:54px;
        .form-action {
            padding:5px 16px;
        }
    }
    .titleEmail{
        display: flex;
        // justify-content:space-around;
        .email{
            padding: 20px  15px;
        }
        .sub{
            padding: 10px  0px 10px 35px;
            width: 50%;
        }
    }
}
</style>